import { Phone } from "lucide-react";
import { IMAGES } from "../lib/funnelData";
import { Reveal } from "./Reveal";

export const AboutJody = () => (
  <section className="relative" data-testid="about-jody">
    <div className="relative overflow-hidden [mask-image:linear-gradient(to_bottom,transparent,black_8%,black_92%,transparent)]">
      <img src={IMAGES.jody} alt="Jody Cann, Broker at Cann Realty" className="absolute inset-0 w-full h-full object-cover object-[75%_10%]" data-testid="about-jody-image" />
      <div className="absolute inset-0 bg-gradient-to-b from-emeraldx-deeper/10 via-emeraldx-deeper/40 to-emeraldx-deeper/95" />
      <div className="absolute inset-0 bg-gradient-to-r from-emeraldx-deeper/75 via-emeraldx-deeper/30 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-3/4 backdrop-blur-md [mask-image:linear-gradient(to_top,black,black_35%,transparent)]" />
      <div className="overlay-grain" />
      <div className="absolute top-8 right-4 sm:right-8 z-10">
        <span className="badge-brand-light" data-testid="about-jody-badge">Meet your broker</span>
      </div>
      <div className="relative min-h-[95vh] flex items-end">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-12 w-full">
          <Reveal className="max-w-2xl">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif text-white [text-wrap:balance]">Jody Cann</h2>
            <span className="rule-gold mt-6" />
            <div className="mt-6 space-y-4 text-base text-white/85 leading-relaxed [text-wrap:pretty]" data-testid="about-jody-bio">
              <p>After 24 years in real estate, no one is more passionate and savvy about this corner of the market than me. Land, farms, and homes across the South Carolina Upstate aren't just my specialty — they're my backyard.</p>
              <p>My deep-rooted knowledge and commitment to excellence have earned me a reputation as a trusted advisor. When a deal gets difficult, I double my efforts — my sellers routinely see properties that sat with other agents sell in weeks, at higher prices.</p>
              <p className="font-semibold text-white">I believe in my business so much, I put my name on the door.</p>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a href="#funnel" data-testid="about-jody-contact-btn" className="inline-flex items-center justify-center rounded-full bg-oak hover:bg-oak-dark text-white px-8 py-3.5 text-xs font-semibold uppercase tracking-[0.15em] transition-colors duration-150 active:scale-[0.96]">
                Work With Me
              </a>
              <a href="tel:8643142752" data-testid="about-jody-call-btn" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/40 text-white px-8 py-3.5 text-xs font-semibold uppercase tracking-[0.15em] hover:bg-white/10 transition-colors duration-150 active:scale-[0.96]">
                <Phone size={15} /> (864) 314-2752
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
